const state = {
  cliente: null,
  clientes: []
}

const getters = {
  clientes(state) {
    return state.clientes;
  },
  cliente(state) {
    return state.cliente;
  }
}

const actions = {
  clearClientes(context) {
    context.commit("clearClientes");
  },
  setClientes(context, payload) {
    context.commit("setClientes", payload.clientes);
  },
  addCliente(context, payload) {
    context.commit("addCliente", payload.cliente);
  }
}

const mutations = {
  setClientes(state, clientes) {
    state.clientes = clientes;
  },
  clearClientes(state) {
    state.clientes = [];
  },
  addCliente(state, cliente) {
    state.clientes.push(cliente);
  }
}


export default {
    state,
    getters,
    mutations,
    actions
}
